import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from 'actions/chat/fileUpload';
import ChatFileUpload from 'components/chat/fileUpload/';

export default connect(
  state => {
    let { fileUpload: fileUploadConfiguration } = state.chat.main.clientConfiguration,
        { fileUpload } = state.chat;
    return {
      token: state.app.token,
      embedded: state.app.embedded,
      title: fileUploadConfiguration.title,
      buttonLabel: fileUploadConfiguration.buttonLabel,
      multiple: fileUploadConfiguration.multiple,
      loading: fileUpload.loading,
      error: fileUpload.error,
      files: fileUpload.files.toJS(),
      progress: fileUpload.fileUploadProgress && fileUpload.fileUploadProgress.toJS(),
      caseNumber: state.chat.main.validationResult.caseNumber,
      allowedFileExtensions: fileUploadConfiguration.allowedFileExtensions,
    };
  },
  dispatch => bindActionCreators({
    onMinimize: actions.minimize,
    onSelectFiles: actions.selectFiles,
    onStartUpload: actions.startUpload,
  }, dispatch)
)(ChatFileUpload);



// WEBPACK FOOTER //
// ./containers/chat/fileUpload/index.js